/**
 * Ruta PÚBLICA de verificación de certificados (guest-first, sin cuenta):
 * `/verify/<certId>` vive FUERA del árbol `/u/<n>` (allowlisted en el
 * beforeLoad del root y en u-router) porque el enlace se comparte fuera de la
 * app — un verificador no tiene por qué tener sesión.
 */
import { createRoute, useParams } from "@tanstack/solid-router";
import { rootRoute } from "@/routes/__root";
import { VerifyCertificateView } from "@/features/courses/components/certificates/verify-view";

function VerifyCertificatePage() {
  const params = useParams({ from: "/verify/$certId" });
  return <VerifyCertificateView certId={params().certId} />;
}

export const verifyCertificateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/verify/$certId",
  component: VerifyCertificatePage,
});
